import {
  AssetResponse,
  AssetsResponse,
  ErrorResponse,
  LogsResponse,
  QueueStatsResponse,
  RestartResponse,
  RevokeResponse,
} from "../types/statusTypes";
import { fetchAuthSession } from "aws-amplify/auth";
import { mapToStatus } from "./statusMapper";
import { removeNullishOrEmpty } from "./helpers";

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type AssetsParams = {
  search?: string;
};

export async function fetchAndMapAssetsAndStatuses(searchParams?: AssetsParams) {
  const query = searchParams && new URLSearchParams(removeNullishOrEmpty(searchParams));
  const path = `/assets${query?.size ? `?${query.toString()}` : ""}`;
  const parsedResult: AssetsResponse = await sendApiRequest<AssetsResponse>(path);
  parsedResult.contentStatuses = parsedResult.contentStatuses.map(mapToStatus);
  return parsedResult;
}

export async function fetchAssetById(id: string) {
  return sendApiRequest<AssetResponse>(`/assets/${id}`);
}

export async function fetchLogsById(id: string) {
  return sendApiRequest<LogsResponse>(`/assets/${id}/logs`);
}

export async function restartJob(asset: string, job: string) {
  return sendApiRequest<RestartResponse>(
    `/assets/${asset}/pipeline_step/${job}/restart`,
    { method: "PATCH" });
}

export async function revokeAsset(asset: string) {
  return sendApiRequest<RevokeResponse>(`/assets/${asset}/revoke`, { method: "PATCH" });
}

export async function fetchQueueStats() {
  return sendApiRequest<QueueStatsResponse>("/stats");
}

async function errorHandler(response: Response) {
  if (!response.ok) {
    const errorData = await response.json() as ErrorResponse;
    const errorMessage = (errorData && errorData.error) || response.statusText;
    throw new Error(errorMessage, { cause: errorData });
  }
}

async function sendApiRequest<T>(path: string, init?: RequestInit) {
  const authSession = await fetchAuthSession();
  const headers = new Headers({ Authorization: authSession.tokens?.accessToken.toString() ?? "" });
  const url = `${window.location.origin}/api${path}`
  const response = await fetch(url, { ...init, headers });
  await errorHandler(response);
  return response.json() as T;
}
